/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ManualFiling } from '../models/manual-filing';
@Injectable({
  providedIn: 'root',
})
class ManualFilingService extends __BaseService {
  static readonly addManualFilingPath = '/manualFiling/adding';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param manualFiling undefined
   * @return returns a status about the process
   */
  addManualFilingResponse(manualFiling: ManualFiling): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = manualFiling;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manualFiling/adding`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param manualFiling undefined
   * @return returns a status about the process
   */
  addManualFiling(manualFiling: ManualFiling): __Observable<boolean> {
    return this.addManualFilingResponse(manualFiling).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module ManualFilingService {
}

export { ManualFilingService }
